export class VoceSezione {
  bootstrapDimension: number;
  tipoDato: string;
  label: string;
  value: string | number | boolean;

  constructor(bootstrapDimension: number, tipoDato: string, label: string, value: string | number | boolean) {
    this.bootstrapDimension = bootstrapDimension;
    this.tipoDato = tipoDato;
    this.label = label;
    this.value = value;
  }
}
